import { render, staticRenderFns } from "./MedicalManage.vue?vue&type=template&id=eab2b47e&scoped=true"
import script from "./MedicalManage.vue?vue&type=script&lang=js"
export * from "./MedicalManage.vue?vue&type=script&lang=js"
import style0 from "./MedicalManage.vue?vue&type=style&index=0&id=eab2b47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab2b47e",
  null
  
)

export default component.exports